import React from 'react';
import { FDPaper, FDStack } from '@facet-wealth/design';
import {
  TruncatedCard,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep/Content/Common/TruncatedCard';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';

export const DataCardWithTruncation = ({
  children, cardContent, cardTitle, test,
}) => {
  return (
    <FDPaper padding={2} appearance={'elevated'} maxWidth={360} flex={1} {...dataAttrs(test)}>
      <TruncatedCard value={cardContent} title={cardTitle}>
        <FDStack direction={'column'} spacing={2} padding={1}>
          {children}
        </FDStack>
      </TruncatedCard>
    </FDPaper>
  );
};

DataCardWithTruncation.defaultProps = {
  cardContent: undefined,
  cardTitle: undefined,
  test: 'data-card',
};

DataCardWithTruncation.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  cardContent: PropTypes.string,
  cardTitle: PropTypes.string,
  test: PropTypes.string,
};
